export default "__VITE_PUBLIC_ASSET__93550f3f__"